import { css } from '@linaria/core';
import { styled } from '@linaria/react';

export const TopicContainer = styled.div`
	display: flex;
	justify-content: center;
`;

export const withMessagesSwitch = css`
	width: 100%;
	justify-content: space-between;
	padding-bottom: 44.5px;
`;

export const messagesSwitch = css`
	position: absolute;
	right: calc(38px + var(--chat-horizontal-padding));
	bottom: 13.25px;
`;

export const reportButtonWithSwitch = css`
	right: calc(3px + var(--chat-horizontal-padding));
	bottom: 10px;
`;
